import logoWhite from '@assets/images/mandrake-logo-large-white.svg'
import { useAuthContext } from '@contexts/authContext'
import useModalContext from '@contexts/modalContext'
import styled from '@emotion/styled'
import { Button, ButtonBase } from '@mui/material'
import { colors, fontSize, size } from '@styles/theme'
import { PiAirplaneInFlightBold, PiAirplaneTiltBold, PiArrowRightBold, PiChatCircleDotsBold, PiCodeBold, PiEyeClosedBold, PiEyeSlashBold, PiMapPinBold, PiStarBold } from 'react-icons/pi'
import { Link } from 'react-router-dom'

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  height: 100%;
  width: 100%;

  // overflow-x: hidden;
  overflow-y: scroll;
`

const MandrakeLogo = styled.img`
  flex-shrink: 0;
  height: ${size(10)};
  width: ${size(10)};
  margin-top: ${size(2)};
`

const Description = styled.p`
  padding: 0 ${size(2)} ${size(0)} ${size(2)};
  text-align: center;
  line-height: ${size(3)};
`

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: ${size(4)} ${size(1)};
`

const LinkButton = styled(ButtonBase)`
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  padding: ${size(2)} ${size(2.5)};
  margin: ${size(0.75)};
  border-radius: 100px;

  font-weight: 300;
`

const LinkRight = styled.span`
  display: flex;
  align-items: center;
`

const SlightBold = styled.b`
  display: flex;
  align-items: center;
  font-weight: 500;
`

const Small = styled.span`
  font-size: ${fontSize('xs')};
  align-self: flex-end;
  padding-bottom: 1px;
`

const FeatureList = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  padding: ${size(2)} ${size(3)};
  // extra space for scrolling
  padding-bottom: ${size(8)};
  gap: ${size(1)} 0;
  margin: 0;
`

const FeatureTitle = styled.b`
  font-size: ${size(2.5)};
  margin-bottom: ${size(1)};
`

const FeatureLi = styled.li`
  display: flex;
  align-items: center;
  // padding-left: ${size(1)};
`

const SubscriptionLanding = () => {
  const { state: authState } = useAuthContext()
  const { registerUser } = useModalContext()
  const isAnonymous = authState?.user?.isAnonymous

  const linkTo = (plan) => {
    return `/subscription?subscription_step=1&plan=${plan}`
  }

  const checkIfRegisterNeeded = (e) => {
    if (isAnonymous) {
      e.preventDefault()
      registerUser.open()
    }
  }

  return (
    <Container>
      <MandrakeLogo src={logoWhite} />
      <Description>
        Become a <b>Supporter</b> and get:<br /><em>Travel Mode, Hidden Mode, Priority Map Placement, and more.</em>
      </Description>
      <ButtonContainer>
        <LinkButton
          style={{
            backgroundColor: colors.statusColors.browsing('lightRgba')(0.45),
            border: `3px solid ${colors.statusColors.browsing('primary')}`,
          }}
          component={Link}
          onClick={checkIfRegisterNeeded}
          to={linkTo('1MONTH')}>
          <SlightBold>1 Month</SlightBold>
          <LinkRight><SlightBold>$3.99</SlightBold>/<Small>mo</Small>&nbsp;<PiArrowRightBold /></LinkRight>
        </LinkButton>
        <LinkButton
          style={{
            backgroundColor: colors.statusColors.right_now('lightRgba')(0.45),
            border: `3px solid ${colors.statusColors.right_now('primary')}`,
          }}
          component={Link}
          onClick={checkIfRegisterNeeded}
          to={linkTo('3MONTH')}>
          <SlightBold>3 Months</SlightBold>
          <LinkRight><SlightBold>$3.66</SlightBold>/<Small>mo</Small>&nbsp;<PiArrowRightBold /></LinkRight>
        </LinkButton>
        <LinkButton
          style={{
            backgroundColor: colors.statusColors.chatting('lightRgba')(0.45),
            border: `3px solid ${colors.statusColors.chatting('primary')}`,
          }}
          component={Link}
          onClick={checkIfRegisterNeeded}
          to={linkTo('6MONTH')}>
          <SlightBold>6 Months</SlightBold>
          <LinkRight><SlightBold>$3.33</SlightBold>/<Small>mo</Small>&nbsp;<PiArrowRightBold /></LinkRight>
        </LinkButton>
        <LinkButton
          style={{
            backgroundColor: colors.statusColors.romance('lightRgba')(0.45),
            border: `3px solid ${colors.statusColors.romance('primary')}`,
          }}
          component={Link}
          onClick={checkIfRegisterNeeded}
          to={linkTo('1YEAR')}>
          <SlightBold>1 Year</SlightBold>
          <LinkRight><SlightBold>$2.91</SlightBold>/<Small>mo</Small>&nbsp;<PiArrowRightBold /></LinkRight>
        </LinkButton>
      </ButtonContainer>
      <FeatureList>
        <FeatureTitle><em>What You Can Expect</em></FeatureTitle>
        <FeatureLi><PiAirplaneInFlightBold />&nbsp;&nbsp;&nbsp;Travel Mode</FeatureLi>
        <FeatureLi><PiEyeSlashBold />&nbsp;&nbsp;&nbsp;Hidden Mode</FeatureLi>
        {/* <FeatureLi><PiStarBold />&nbsp;&nbsp;&nbsp;Favoriting Chats</FeatureLi> */}
        <FeatureLi><PiChatCircleDotsBold />&nbsp;&nbsp;&nbsp;Never Expiring Chats</FeatureLi>
        <FeatureLi><PiMapPinBold />&nbsp;&nbsp;&nbsp;Higher Placement On The Map</FeatureLi>
        <FeatureLi><PiCodeBold />&nbsp;&nbsp;&nbsp;Newly Developing Features</FeatureLi>
      </FeatureList>
    </Container> 
  )
}

export default SubscriptionLanding
